<template>
  <div class="user_list_page">

    <business-group 
      v-if="isDeviceModelsLoaded"
      :tableConfig="{ ...tableConfig, rowSelection }" 
      :formConfig="{ ...formConfig }" 
      :formValues="dynamicFormValues"
      ref="businessGroup"
    >
      <!-- 表格上方操作按钮 -->
      <template #tableAction>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="display: flex; align-items: center;">
            <a-select 
              placeholder="请选择设备型号" 
              v-model="selectedDeviceModel"
              style="width: 250px;" 
              allowClear
              @change="handleDeviceModelChange"
            >
              <a-select-option v-for="model in deviceModels" :key="model.deviceModel"
                :value="model.deviceModel">
                <span style="display: inline-block; width: 80px;">{{ model.modelName }}</span>
                <span>{{ model.deviceDescription }}</span>
              </a-select-option>
            </a-select>
            <a-button type="primary" @click="handleBatchCopy" :disabled="selectedRowKeys.length === 0"
              style="margin-left: 10px;">
              <a-icon type="copy" />
              一键复制 ({{ selectedRowKeys.length }})
            </a-button>
            <a-button type="primary" @click="handleBatchShelf" :disabled="selectedRowKeys.length === 0 || !canBatchShelf"
              style="margin-left: 10px;">
              <a-icon type="arrow-up" />
              一键上架 ({{ selectedRowKeys.length }})
            </a-button>
            <a-button type="primary" @click="handleBatchConfirm" :disabled="selectedRowKeys.length === 0 || !canBatchConfirm"
              style="margin-left: 10px;">
              <a-icon type="check" />
              一键确认 ({{ selectedRowKeys.length }})
            </a-button>
            <a-button type="primary" @click="handleBatchUnShelf" :disabled="selectedRowKeys.length === 0 || !canBatchUnShelf"
              style="margin-left: 10px;">
              <a-icon type="arrow-down" />
              一键下架 ({{ selectedRowKeys.length }})
            </a-button>
            <a-button type="primary" @click="handleBatchDelete" :disabled="selectedRowKeys.length === 0 || !canBatchDelete"
              style="margin-left: 10px;">
              <a-icon type="delete" />
              一键删除 ({{ selectedRowKeys.length }})
            </a-button>
            <a-button type="primary" @click="handleExportExcel" :disabled="selectedRowKeys.length === 0 || !canBatchExport"
              style="margin-left: 10px;">
              <a-icon type="download" />
              Excel导出 ({{ selectedRowKeys.length }})
            </a-button>
            <a-button type="primary" @click="handleRefreshList" style="margin-left: 10px;">
              <a-icon type="reload" />
              刷新
            </a-button>
          </div>
          <div>
            <a-upload
              :beforeUpload="handleImportExcel"
              :showUploadList="false"
              accept=".xlsx,.xls"
            >
              <a-button type="primary">
                <a-icon type="upload" />
                Excel导入
              </a-button>
            </a-upload>
          </div>
        </div>
      </template>
      
      <!-- 查询 -->
      <template #formSlot>
        <a-form-item>
          <a-input placeholder="请输入场景名称" v-decorator="['effectName']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" />
        </a-form-item>
        <a-form-item>
          <a-select placeholder="请选择场景所属类别" v-decorator="['effectType']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" allowClear>
            <a-select-option v-for="item in effectTypeList" :key="item.effectType" :value="item.effectType">
              {{ item.effectType }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select placeholder="请选择场景版本" v-decorator="['sceneVersion']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" allowClear>
            <a-select-option v-for="item in sceneVersionList" :key="item.version" :value="item.version">
              Ver{{ item.version }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select placeholder="请选择光效应用版本" v-decorator="['effectVersion']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" allowClear>
            <a-select-option v-for="item in effectVersionList" :key="item.version" :value="item.version">
              V{{ item.version }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select placeholder="请选择状态" v-decorator="['status']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" allowClear>
            <a-select-option value="0">未上架</a-select-option>
            <a-select-option value="1">已上架</a-select-option>
            <a-select-option value="2">已确认</a-select-option>
          </a-select>
        </a-form-item>
      </template>

      <!-- 状态格式化 -->
      <template #status="record">
        {{ ['未上架', '已上架', '已确认'][record.status] || record.status }}
      </template>

      <!-- 创建时间格式化 -->
      <template #createTime="record">
        {{ dataFormatStr(record.createTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>

      <!-- 修改时间格式化 -->
      <template #updateTime="record">
        {{ dataFormatStr(record.updateTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>

      <!--  场景速度    -->
      <template slot="effectOrder" slot-scope="record">
        {{ ['', '标准', '慢', '快'][record.effectOrder] || record.effectOrder }}
      </template>

      <!--  场景版本    -->
      <template slot="sceneVersion" slot-scope="record">
        {{ record.sceneVersion ? `Ver${record.sceneVersion}` : record.sceneVersion }}
      </template>

      <!--  光效版本    -->
      <template slot="effectVersion" slot-scope="record">
        {{ record.effectVersion ? `V${record.effectVersion}` : record.effectVersion }}
      </template>

      <!--  选中图标格式化    -->
      <template slot="icon" slot-scope="record">
        <img width="30" :src="record.icon" />
      </template>

      <!--  选中图标格式化    -->
      <template slot="icon" slot-scope="record">
        <img width="30" :src="record.icon" />
      </template>

      <!--  选中图标格式化    -->
      <template slot="selectedIcon" slot-scope="record">
        <img width="30" :src="record.selectedIcon" />
      </template>

      <!--  场景速度    -->
      <template slot="creator" slot-scope="record">
        {{ record.creator === 0 ? 'admin' : record.creator }}
      </template>

      <!-- 拖拽句柄 -->
      <template #drag="record">
        <span class="drag-handle"><a-icon type="drag" /></span>
      </template>

      <!-- 操作 -->
      <template #action="record">
        <a-space>
          <!-- 状态为0：未上架 -->
          <template v-if="record.status === 0">
            <a-button type="link" @click="() => batchShelf(record)">上架</a-button>
            <a-button type="link" @click="() => showUpdateForm(record)">编辑</a-button>
            <a-button type="link" @click="() => batchCopy(record)">复制</a-button>
            <a-button type="link" @click="() => deleted(record)">删除</a-button>
          </template>
          <!-- 状态为1：已上架 -->
          <template v-else-if="record.status === 1">
            <a-button type="link" @click="() => batchConfirm(record)">确认</a-button>
            <a-button type="link" @click="() => batchCopy(record)">复制</a-button>
            <a-button type="link" @click="() => batchUnShelf(record)">下架</a-button>
          </template>
          <!-- 状态为2：已确认 -->
          <template v-else-if="record.status === 2">
            <a-button type="link" @click="() => batchCopy(record)">复制</a-button>
            <a-button type="link" @click="() => batchUnShelf(record)">下架</a-button>
          </template>
        </a-space>
      </template>

    </business-group>

    <!-- 复制弹窗 -->
    <a-modal
      :title="copyRecords.length > 1 ? `批量复制 (${copyRecords.length}条)` : '复制场景特效'"
      :visible="copyModalVisible"
      :confirmLoading="copyFormLoading"
      @ok="handleCopySubmit"
      @cancel="handleCopyCancel"
      width="500px"
    >
      <a-form layout="vertical">
        <a-form-item label="场景版本">
          <a-input 
            placeholder="请输入场景版本（格式：x.y）" 
            v-model="copySceneVersion"
            style="width: 100%;" 
            prefix="Ver"
          />
        </a-form-item>
        <a-form-item label="光效应用版本">
          <a-input 
            placeholder="请输入光效应用版本（格式：x.y）" 
            v-model="copyEffectVersion"
            style="width: 100%;" 
            prefix="V"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <!--  编辑弹窗  -->
    <a-modal title="编辑场景特效" destroyOnClose :visible="updateVisible" :maskClosable="false" @ok="update"
      @cancel="() => updateVisible = false" width="500px">
      <a-form-model :modal="updateFrom" layout="vertical" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="id:" v-show="false">
          <a-input placeholder="id" v-model="updateFrom.id" showCount :maxlength="64" />
        </a-form-model-item>
        <a-form-model-item label="设备名称:" v-show="false">
          <a-input placeholder="请输入设备名称" v-model="updateFrom.modelName" disabled />
        </a-form-model-item>
        <a-form-model-item label="设备类型:" v-show="false">
          <a-input placeholder="请输入设备类型" v-model="updateFrom.deviceType" disabled />
        </a-form-model-item>
        <a-form-model-item label="设备型号:" v-show="false">
          <a-input placeholder="请输入设备型号" v-model="updateFrom.deviceModel" disabled />
        </a-form-model-item>
        <a-form-model-item label="已导入场景效果表:" v-show="false">
          <a-select placeholder="已导入场景效果表" v-model="updateFrom.status" disabled>
            <a-select-option value="0">否</a-select-option>
            <a-select-option value="1">是</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="创建人:" v-show="false">
          <a-input placeholder="创建人" v-model="updateFrom.creator" disabled />
        </a-form-model-item>
        <a-form-model-item label="创建时间:" v-show="false">
          <a-input placeholder="创建时间" v-model="updateFrom.createTime" disabled />
        </a-form-model-item>
        <a-form-model-item label="场景名称:">
          <a-select placeholder="请选择场景名称" v-model="updateFrom.effectName" allowClear>
            <a-select-option v-for="item in updateEffectNameList" :key="item.chineseName" :value="item.chineseName">
              {{ item.chineseName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="所属分类:">
          <a-select placeholder="请选择所属分类" v-model="updateFrom.effectType" allowClear>
            <a-select-option v-for="item in updateEffectTypeList" :key="item.effectType" :value="item.effectType">
              {{ item.effectType }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="场景排序:">
          <a-input placeholder="请输入排序" v-model="updateFrom.sortNumber" />
        </a-form-model-item>
        <a-form-model-item label="场景速度:">
          <a-select placeholder="请选择场景速度" v-model="updateFrom.effectOrder">
            <a-select-option value="1">标准</a-select-option>
            <a-select-option value="2">慢</a-select-option>
            <a-select-option value="3">快</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="场景版本:">
          <a-input placeholder="请输入场景版本" v-model="updateFrom.sceneVersion" prefix="Ver" />
        </a-form-model-item>
        <a-form-model-item label="光效应用版本:">
          <a-input placeholder="请输入光效版本" v-model="updateFrom.effectVersion" prefix="V" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import { tips } from "@/utils/util";
import { formatToStr } from "@/utils/dateUtils";
import axios from "axios";
import Sortable from 'sortablejs';

export default {
  components: {
    pageTitle,
    businessGroup
  },
  data() {
    return {
      tableConfig: {
        url: "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/pages",
        rowKey: "id",
        columns: [
          // {
          //   title: "",
          //   key: "drag",
          //   width: 60,
          //   align: "center",
          //   scopedSlots: { customRender: "drag" },
          // },
          {
            title: "场景排序",
            dataIndex: "sortNumber",
            key: "sortNumber",
            align: "center",
            ellipsis: true,
            width: 90
          },
          {
            title: "效果ID",
            dataIndex: "id",
            key: "id",
            align: "center",
            ellipsis: true,
            width: 90
          },
          {
            title: "设备名称",
            dataIndex: "modelName",
            key: "modelName",
            align: "center",
            ellipsis: true,
            width: 100
          },
          {
            title: "场景所属类别",
            dataIndex: "effectType",
            key: "effectType",
            align: "center",
            ellipsis: true,
            width: 120
          },
          {
            title: "场景名称",
            dataIndex: "effectName",
            key: "effectName",
            align: "center",
            ellipsis: true,
            width: 200
          },
          {
            title: "场景速度",
            key: "effectOrder",
            align: "center",
            ellipsis: true,
            scopedSlots: { customRender: "effectOrder" },
            width: 100
          },
          {
            title: "场景版本",
            key: "sceneVersion",
            align: "center",
            ellipsis: true,
            width: 100,
            scopedSlots: { customRender: "sceneVersion" }
          },
          {
            title: "光效应用版本",
            key: "effectVersion",
            align: "center",
            ellipsis: true,
            width: 120,
            scopedSlots: { customRender: "effectVersion" }
          },
          {
            title: "未选中图标",
            key: "icon",
            align: "center",
            ellipsis: true,
            scopedSlots: { customRender: "icon" },
            width: 120
          },
          {
            title: "选中图标",
            key: "selectedIcon",
            align: "center",
            ellipsis: true,
            scopedSlots: { customRender: "selectedIcon" },
            width: 120
          },
          {
            title: "状态",
            key: "status",
            scopedSlots: { customRender: "status" },
            align: "center",
            width: 120
          },
          {
            title: "创建时间",
            key: "createTime",
            scopedSlots: { customRender: "createTime" },
            align: "center",
            width: 160
          },
          {
            title: "操作",
            align: "center",
            fixed: "right",
            scopedSlots: { customRender: "action" }
          }
        ]
      },
      formConfig: {
        timeShow: false,
        formShow: true
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 30 },
      updateVisible: false,
      effectTypeList: [], // 场景类别下拉列表数据（查询表单用）
      updateEffectTypeList: [], // 编辑弹窗的场景类别下拉列表数据
      updateEffectNameList: [], // 编辑弹窗的场景名称下拉列表数据
      sceneVersionList: [], // 场景版本下拉列表数据
      effectVersionList: [], // 光效应用版本下拉列表数据
      deviceModels: [], // 设备型号选项数组
      selectedDeviceModel: undefined, // 默认选中的设备型号
      selectedDeviceType: undefined, // 默认选中的设备类型
      selectedDeviceModelStorageKey: "diySceneEffect:selectedDeviceModel", // 记忆最后选中的设备型号
      formValues: {}, // 额外的查询参数
      isDeviceModelsLoaded: false, // 设备型号是否已加载完成
      selectedRowKeys: [], // 选中的行 keys
      selectedRows: [], // 选中的行数据
      copyModalVisible: false, // 复制弹窗显示状态
      copyFormLoading: false, // 复制表单加载状态
      copyTargetDeviceModel: null, // 复制目标设备型号（已废弃，保留兼容）
      copySceneVersion: "", // 复制的目标场景版本
      copyEffectVersion: "", // 复制的目标光效应用版本
      copyRecord: null, // 待复制的记录数据（单行复制时使用，已废弃）
      copyRecords: [], // 待复制的记录数据数组（支持批量复制）
      // 修改表单
      updateFrom: {
        id: "",
        modelName: "",
        deviceType: "",
        deviceModel: "",
        status: "",
        creator: "",
        createTime: "",
        effectName: "",
        effectType: "",
        sortNumber: "",
        effectOrder: "",
        sceneVersion: "",
        effectVersion: ""
      }
    };
  },
  computed: {
    // 动态生成 rowSelection 配置
    rowSelection() {
      return {
        type: 'checkbox',
        selectedRowKeys: this.selectedRowKeys, // 绑定选中的 keys，实现响应式更新
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        }
      };
    },
    // 动态生成表单查询参数
    dynamicFormValues() {
      const values = { ...this.formValues };
      // 如果选择了设备型号，添加到查询参数中
      if (this.selectedDeviceModel) {
        values.deviceModel = this.selectedDeviceModel;
      }
      // 如果选择了设备类型，添加到查询参数中
      if (this.selectedDeviceType) {
        values.deviceType = this.selectedDeviceType;
      }
      return values;
    },
    // 判断是否满足拖拽排序条件（同状态+同场景所属类别+同场景版本）
    canDragSort() {
      // 获取当前表格数据源
      const dataSource = this.$refs.businessGroup?.dataSource || [];
      
      if (dataSource.length === 0) {
        return false;
      }

      // 提取所有行的状态、场景类别、场景版本
      const statuses = [...new Set(dataSource.map(item => item.status))];
      const effectTypes = [...new Set(dataSource.map(item => item.effectType))];
      const sceneVersions = [...new Set(dataSource.map(item => item.sceneVersion))];

      // 只有当所有行的状态、场景类别、场景版本都相同时，才允许拖拽
      return statuses.length === 1 && effectTypes.length === 1 && sceneVersions.length === 1;
    },
    // 判断是否可以批量上架（所有选中的数据状态都为0-未上架）
    canBatchShelf() {
      if (this.selectedRows.length === 0) {
        return false;
      }
      // 检查所有选中的行状态是否都为0（未上架）
      return this.selectedRows.every(row => row.status === 0);
    },
    // 判断是否可以批量确认（所有选中的数据状态都为1-已上架）
    canBatchConfirm() {
      if (this.selectedRows.length === 0) {
        return false;
      }
      // 检查所有选中的行状态是否都为1（已上架）
      return this.selectedRows.every(row => row.status === 1);
    },
    // 判断是否可以批量导出（所有选中的数据状态都为2-已确认）
    canBatchExport() {
      if (this.selectedRows.length === 0) {
        return false;
      }
      // 检查所有选中的行状态是否都为2（已确认）
      return this.selectedRows.every(row => row.status === 2);
    },
    // 判断是否可以批量下架（所有选中的数据状态都为1-已上架或2-已确认）
    canBatchUnShelf() {
      if (this.selectedRows.length === 0) {
        return false;
      }
      // 检查所有选中的行状态是否都为1（已上架）或2（已确认）
      return this.selectedRows.every(row => [1, 2].includes(row.status));
    },
    // 判断是否可以批量删除（所有选中的数据状态都为0-未上架）
    canBatchDelete() {
      if (this.selectedRows.length === 0) {
        return false;
      }
      // 检查所有选中的行状态是否都为0（未上架）
      return this.selectedRows.every(row => row.status === 0);
    }
  },
  mounted() {
    // 获取设备型号列表
    this.fetchDeviceModels();
    // 注意：场景类别列表将在设备型号加载完成后，由 fetchDeviceModels 的回调中调用
    
    // 初始化拖动排序功能（等待表格渲染完成后）
    this.$nextTick(() => {
      setTimeout(() => {
        this.initDragSort();
      }, 500);
    });
  },
  methods: {
    // 初始化拖动排序功能
    initDragSort() {
      this.$nextTick(() => {
        const tableBody = this.$refs.businessGroup?.$el?.querySelector('.ant-table-tbody');
        if (!tableBody) {
          console.warn('未找到表格tbody元素');
          return;
        }

        Sortable.create(tableBody, {
          animation: 150,
          handle: '.drag-handle', // 拖动句柄类名
          onMove: (evt) => {
            // 在拖动过程中检查是否满足条件
            if (!this.canDragSort) {
              tips(this, false, '只有当所有数据的状态、场景所属类别、场景版本都相同时，才能拖动排序');
              return false; // 阻止拖动
            }
            return true; // 允许拖动
          },
          onEnd: async (evt) => {
            const { oldIndex, newIndex } = evt;
            
            // 如果位置没有变化，不处理
            if (oldIndex === newIndex) return;

            // 再次检查是否满足拖拽条件
            if (!this.canDragSort) {
              tips(this, false, '只有当所有数据的状态、场景所属类别、场景版本都相同时，才能拖动排序');
              // 刷新表格以恢复原顺序
              this.refreshData();
              return;
            }

            console.log('拖动排序 - 原索引:', oldIndex, '新索引:', newIndex);

            // 获取当前数据源
            const dataSource = this.$refs.businessGroup?.dataSource || [];
            
            if (dataSource.length === 0) {
              tips(this, false, '数据为空，无法更新排序');
              return;
            }

            // 移动数据（注意：Sortable的索引从0开始，但表头也占一行）
            // oldIndex 和 newIndex 已经排除了表头，直接使用即可
            const movedItem = dataSource.splice(oldIndex, 1)[0];
            dataSource.splice(newIndex, 0, movedItem);

            // 调用后端接口更新排序
            await this.updateSortOrder(dataSource);
          }
        });
      });
    },
    
    // 更新排序序号
    async updateSortOrder(dataSource) {
      try {
        // 提取ID和新的排序号
        const sortData = dataSource.map((item, index) => ({
          id: item.id,
          sortNumber: index + 1 // 排序号从1开始
        }));

        console.log('更新排序数据:', sortData);

        // 调用批量更新排序接口
        const result = await this.$post(
          'bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/batchUpdateSort',
          sortData
        );

        if (result?.resultStatus) {
          tips(this, true, '排序更新成功');
          // 刷新表格
          this.refreshData();
        } else {
          tips(this, false, result?.errorMessage || '排序更新失败');
          // 失败时刷新表格以恢复原顺序
          this.refreshData();
        }
      } catch (error) {
        console.error('排序更新失败:', error);
        tips(this, false, '排序更新失败');
        // 失败时刷新表格以恢复原顺序
        this.refreshData();
      }
    },
    // 刷新
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },
    // 设备型号变化处理
    handleDeviceModelChange(value) {
      console.log("设备型号变化:", value);
      
      if (value) {
        const selectedModel = this.deviceModels.find(model => model.deviceModel === value);
        if (selectedModel) {
          this.selectedDeviceType = selectedModel.deviceType;
          localStorage.setItem(this.selectedDeviceModelStorageKey, selectedModel.deviceModel);
          
          // 联动逻辑：型号变更时，重新并发获取下拉数据
          Promise.all([
            this.fetchEffectTypeList(),
            this.fetchSceneVersionList(),
            this.fetchEffectVersionList()
          ]).then(() => {
            // 下拉数据更新后，刷新表格列表（入参 deviceModel 已通过计算属性自动更新）
            this.refreshData();
          });
        }
      } else {
        // 清空选择时，重置所有相关状态
        this.selectedDeviceType = undefined;
        localStorage.removeItem(this.selectedDeviceModelStorageKey);
        this.effectTypeList = [];
        this.sceneVersionList = [];
        this.effectVersionList = [];
        this.$refs?.["businessGroup"]?.resetFormFields?.(['effectType', 'sceneVersion', 'effectVersion']);
        
        // 如果业务允许在无型号时显示空表格或全量数据，可在此调用 refreshData
        // 若必须要求有型号才能查询，则不调用
      }
    },
    // 获取设备型号列表
    async fetchDeviceModels() {
      try {
        const result = await this.$get("bluetoothlight/web/router/neewerhome/manage/device/classification/get");
        if (result?.resultStatus && result.resultData) {
          this.deviceModels = result.resultData;
          if (this.deviceModels.length > 0) {
            const cachedDeviceModel = localStorage.getItem(this.selectedDeviceModelStorageKey);
            const selectedModel = this.deviceModels.find(model => model.deviceModel === cachedDeviceModel) || this.deviceModels[0];
            this.selectedDeviceModel = selectedModel.deviceModel;
            // 同时设置 deviceType
            this.selectedDeviceType = selectedModel.deviceType;
            
            // 2. 并发获取三个下拉数据
            await Promise.all([
              this.fetchEffectTypeList(),
              this.fetchSceneVersionList(),
              this.fetchEffectVersionList()
            ]);
          }
        } else {
          console.warn("获取设备型号列表为空或失败");
        }
      } catch (error) {
        console.error("获取设备型号失败:", error);
        tips(this, false, "获取设备型号失败");
      } finally {
        // 3. 无论成功与否，都标记为已加载，触发表格渲染（第3步）
        // 此时 dynamicFormValues 中已包含 deviceModel，表格会自动发起请求
        this.isDeviceModelsLoaded = true;
      }
    },
    // 获取场景类别下拉列表
    async fetchEffectTypeList() {
      // 如果没有选择设备型号，则不请求接口
      if (!this.selectedDeviceModel || !this.selectedDeviceType) {
        this.effectTypeList = [];
        return;
      }

      try {
        const result = await this.$get("bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/getEffectTypeDropdownList", {
          deviceType: this.selectedDeviceType,
          deviceModel: this.selectedDeviceModel
        });
        if (result?.resultStatus && result.resultData) {
          this.effectTypeList = result.resultData;
        } else {
          console.warn("获取场景类别列表失败:", result?.message);
          this.effectTypeList = [];
        }
      } catch (error) {
        console.error("获取场景类别列表异常:", error);
        tips(this, false, "获取场景类别列表失败");
        this.effectTypeList = [];
      }
    },
    // 获取编辑弹窗的场景类别下拉列表
    async fetchUpdateEffectTypeList(deviceType, deviceModel) {
      // 如果没有设备类型和型号，则不请求接口
      if (!deviceType || !deviceModel) {
        this.updateEffectTypeList = [];
        return;
      }

      try {
        const result = await this.$get("bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/getEffectTypeDropdownList", {
          deviceType: deviceType,
          deviceModel: deviceModel
        });
        if (result?.resultStatus && result.resultData) {
          this.updateEffectTypeList = result.resultData;
        } else {
          console.warn("获取场景类别列表失败:", result?.message);
          this.updateEffectTypeList = [];
        }
      } catch (error) {
        console.error("获取场景类别列表异常:", error);
        tips(this, false, "获取场景类别列表失败");
        this.updateEffectTypeList = [];
      }
    },
    // 获取编辑弹窗的场景名称下拉列表
    async fetchUpdateEffectNameList() {
      try {
        const result = await this.$get("bluetoothlight/web/router/neewerhome/manage/device/sceneEffectIcon/getChineseNameDropdownList");
        if (result?.resultStatus && result.resultData) {
          this.updateEffectNameList = result.resultData;
        } else {
          console.warn("获取场景名称列表失败:", result?.message);
          this.updateEffectNameList = [];
        }
      } catch (error) {
        console.error("获取场景名称列表异常:", error);
        tips(this, false, "获取场景名称列表失败");
        this.updateEffectNameList = [];
      }
    },
    // 获取场景版本下拉列表
    async fetchSceneVersionList() {
      // 如果没有选择设备型号，则不请求接口
      if (!this.selectedDeviceModel || !this.selectedDeviceType) {
        this.sceneVersionList = [];
        return;
      }

      try {
        const result = await this.$get("bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/getSceneVersionDropdownList", {
          deviceType: this.selectedDeviceType,
          deviceModel: this.selectedDeviceModel
        });
        if (result?.resultStatus && result.resultData) {
          this.sceneVersionList = result.resultData;
        } else {
          console.warn("获取场景版本列表失败:", result?.message);
          this.sceneVersionList = [];
        }
      } catch (error) {
        console.error("获取场景版本列表异常:", error);
        tips(this, false, "获取场景版本列表失败");
        this.sceneVersionList = [];
      }
    },
    // 获取光效应用版本下拉列表
    async fetchEffectVersionList() {
      // 如果没有选择设备型号，则不请求接口
      if (!this.selectedDeviceModel || !this.selectedDeviceType) {
        this.effectVersionList = [];
        return;
      }

      try {
        const result = await this.$get("bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/getEffectVersionDropdownList", {
          deviceType: this.selectedDeviceType,
          deviceModel: this.selectedDeviceModel
        });
        if (result?.resultStatus && result.resultData) {
          this.effectVersionList = result.resultData;
        } else {
          console.warn("获取光效应用版本列表失败:", result?.message);
          this.effectVersionList = [];
        }
      } catch (error) {
        console.error("获取光效应用版本列表异常:", error);
        tips(this, false, "获取光效应用版本列表失败");
        this.effectVersionList = [];
      }
    },
    // 时间格式化
    dataFormatStr(ret, format) {
      if (!ret) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD HH:mm:ss";
      }
      return formatToStr(ret, format);
    },

    // 修改弹窗
    showUpdateForm: async function (record) {
      this.updateFrom = {
        id: record.id,
        modelName: record.modelName,
        deviceType: record.deviceType,
        deviceModel: record.deviceModel,
        status: String(record.status),
        creator: record.creator === 0 ? 'admin' : record.creator,
        createTime: this.dataFormatStr(record.createTime),
        effectName: record.effectName,
        effectType: record.effectType,
        sortNumber: record.sortNumber,
        effectOrder: String(record.effectOrder),
        sceneVersion: record.sceneVersion,
        effectVersion: record.effectVersion
      };
      
      // 根据当前行的 deviceType 和 deviceModel 获取所属分类下拉数据，同时获取场景名称下拉数据
      await Promise.all([
        this.fetchUpdateEffectTypeList(record.deviceType, record.deviceModel),
        this.fetchUpdateEffectNameList()
      ]);
      
      this.updateVisible = true;
    },
    // 修改
    update: async function () {
      let url = "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/update";
      try {
        const result = await this.$post(url, this.updateFrom);
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.updateVisible = false;
        }
      } catch (error) {
        console.error("修改DIY场景特效时发生错误:", error);
        tips(this, false, "修改DIY场景特效时发生错误");
      }
    },

    // 导入特效
    exported: function (record) {
      if (record.status === 1) {
        let _this = this;
        this.$confirm({
          title: "已导入特效表，是否要覆盖特效",
          onOk() {
            _this.confirmExported(record);
          },
          onCancel() {
          },
          class: "test"
        });
      } else {
        this.confirmExported(record);
      }
    },

    // 确定导入
    confirmExported: async function (record) {
      let url = "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/export";
      try {
        const result = await this.$get(url, { "id": record.id });
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.updateVisible = false;
        }
      } catch (error) {
        console.error("导入时发生错误:", error);
        tips(this, false, "导入时发生错误");
      }
    },

    // 删除
    deleted: async function (record) {
      let url = "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/delete";
      try {
        const result = await this.$get(url, { "id": record.id });
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.updateVisible = false;
        }
      } catch (error) {
        console.error("删除时发生错误:", error);
        tips(this, false, "删除时发生错误");
      }
    },

    // 一键删除（批量删除）
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        tips(this, false, "请先选择要删除的数据");
        return;
      }
      if (!this.canBatchDelete) {
        tips(this, false, "只能删除未上架的数据");
        return;
      }

      const recordsArray = this.selectedRows;
      const ids = recordsArray.map(record => record.id);

      this.$confirm({
        title: "确认删除",
        content: `是否确认删除选中的 ${recordsArray.length} 条场景特效？`,
        onOk: async () => {
          let url = "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/batchDelete";
          try {
            const result = await this.$post(url, ids);
            const resultStatus = result?.resultStatus;
            if (resultStatus) {
              const deletedEffectNames = Array.isArray(result?.resultData)
                ? result.resultData.map(item => typeof item === "string" ? item : item?.effectName).filter(Boolean)
                : [result?.resultData].filter(Boolean);
              const deletedEffectNameText = deletedEffectNames.join("，");
              tips(this, true, deletedEffectNameText ? `成功删除【${deletedEffectNameText}】` : "删除成功");
              this.selectedRowKeys = [];
              this.selectedRows = [];
              this.refreshData();
            } else {
              tips(this, false, result?.message || "删除失败");
            }
          } catch (error) {
            console.error("删除时发生错误:", error);
            tips(this, false, "删除时发生错误");
          }
        }
      });
    },

    // 通用上架方法（支持单行和多行）
    shelfData(records) {
      // 如果传入的是单个对象，转换为数组
      const recordsArray = Array.isArray(records) ? records : [records];
      
      if (recordsArray.length === 0) {
        tips(this, false, "没有可上架的数据");
        return;
      }

      // 提取ID数组
      const ids = recordsArray.map(record => record.id);

      this.$confirm({
        title: "确认上架",
        content: recordsArray.length > 1 
          ? `是否确认上架选中的 ${recordsArray.length} 条场景特效？` 
          : "是否确认上架该场景特效？",
        onOk: async () => {
          let url = "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/batchShelf";
          try {
            const result = await this.$post(url, ids);
            const resultStatus = result?.resultStatus;
            if (resultStatus) {
              const shelvedEffectList = Array.isArray(result?.resultData)
                ? result.resultData
                : [result?.resultData].filter(Boolean);
              const shelvedEffectNames = shelvedEffectList
                .map(item => typeof item === "string" ? item : item?.effectName)
                .filter(Boolean);
              const shelvedEffectNameText = shelvedEffectNames.map(name => `“${name}”`).join("、");
              tips(this, true, shelvedEffectList.length === 0 ? "上架成功" : `${shelvedEffectNameText}已上架，请勿重复上架`);
              
              // 如果是批量操作，清空选中状态
              if (recordsArray.length > 1) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }
              
              this.refreshData();
            } else {
              tips(this, false, result?.message || "上架失败");
            }
          } catch (error) {
            console.error("上架时发生错误:", error);
            tips(this, false, "上架时发生错误");
          }
        }
      });
    },
    
    // 一键上架（批量上架）
    handleBatchShelf() {
      if (this.selectedRows.length === 0) {
        tips(this, false, "请先选择要上架的数据");
        return;
      }
      this.shelfData(this.selectedRows);
    },

    // 单行上架
    batchShelf(record) {
      this.shelfData(record);
    },

    // 通用下架方法（支持单行和多行）
    unShelfData(records) {
      // 如果传入的是单个对象，转换为数组
      const recordsArray = Array.isArray(records) ? records : [records];

      if (recordsArray.length === 0) {
        tips(this, false, "没有可下架的数据");
        return;
      }

      // 提取ID数组
      const ids = recordsArray.map(record => record.id);

      this.$confirm({
        title: "确认下架",
        content: recordsArray.length > 1
          ? `是否确认下架选中的 ${recordsArray.length} 条场景特效？`
          : "是否确认下架该场景特效？",
        onOk: async () => {
          let url = "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/batchUnShelf";
          try {
            const result = await this.$post(url, ids);
            const resultStatus = result?.resultStatus;
            if (resultStatus) {
              const count = recordsArray.length;
              tips(this, true, count > 1 ? `成功下架 ${count} 条数据` : "下架成功");

              // 如果是批量操作，清空选中状态
              if (recordsArray.length > 1) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }

              this.refreshData();
            } else {
              tips(this, false, result?.message || "下架失败");
            }
          } catch (error) {
            console.error("下架时发生错误:", error);
            tips(this, false, "下架时发生错误");
          }
        }
      });
    },

    // 一键下架（批量下架）
    handleBatchUnShelf() {
      if (this.selectedRows.length === 0) {
        tips(this, false, "请先选择要下架的数据");
        return;
      }
      this.unShelfData(this.selectedRows);
    },

    // 单行下架
    batchUnShelf(record) {
      this.unShelfData(record);
    },

    // 通用确认方法（支持单行和多行）
    confirmData(records) {
      // 如果传入的是单个对象，转换为数组
      const recordsArray = Array.isArray(records) ? records : [records];
      
      if (recordsArray.length === 0) {
        tips(this, false, "没有可确认的数据");
        return;
      }

      // 提取ID数组
      const ids = recordsArray.map(record => record.id);

      this.$confirm({
        title: "确认操作",
        content: recordsArray.length > 1 
          ? `是否已完成对选中 ${recordsArray.length} 条光效的确认？` 
          : "是否已完成对选中光效的确认？",
        onOk: async () => {
          let url = "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/batchConfirm";
          try {
            const result = await this.$post(url, ids);
            const resultStatus = result?.resultStatus;
            if (resultStatus) {
              const count = recordsArray.length;
              tips(this, true, count > 1 ? `成功确认 ${count} 条数据` : "确认成功");
              
              // 如果是批量操作，清空选中状态
              if (recordsArray.length > 1) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }
              
              this.refreshData();
            } else {
              tips(this, false, result?.message || "确认失败");
            }
          } catch (error) {
            console.error("确认时发生错误:", error);
            tips(this, false, "确认时发生错误");
          }
        }
      });
    },
    
    // 一键确认（批量确认）
    handleBatchConfirm() {
      if (this.selectedRows.length === 0) {
        tips(this, false, "请先选择要确认的数据");
        return;
      }
      this.confirmData(this.selectedRows);
    },

    // 单行确认
    batchConfirm(record) {
      this.confirmData(record);
    },

    // Excel导出
    async handleExportExcel() {
      if (this.selectedRows.length === 0) {
        tips(this, false, "请先选择要导出的数据");
        return;
      }

      try {
        // 提取ID数组
        const ids = this.selectedRows.map(record => record.id);

        console.log('导出接口URL:', 'bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/exportExcel');
        console.log('导出参数:', ids);

        // 调用后端接口获取文件下载链接
        const response = await this.$post(
          'bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/exportExcel',
          ids
        );

        console.log('后端响应:', response);

        // 检查响应中是否包含文件链接
        if (!response || !response.resultData) {
          throw new Error('未获取到文件下载链接');
        }

        // 获取文件下载链接
        const fileUrl = response.resultData;
        console.log('文件下载链接:', fileUrl);

        // 创建隐藏的下载链接
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'DIY场景效果数据.xlsx';
        link.style.display = 'none';

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);

        // 清空选中状态
        this.selectedRowKeys = [];
        this.selectedRows = [];

        tips(this, true, '导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        
        // 提供更明确的错误提示
        if (error.code === 'ECONNABORTED') {
          tips(this, false, '导出超时，请检查网络连接');
        } else if (error.response) {
          tips(this, false, `导出失败：${error.response.status} ${error.response.statusText}`);
        } else {
          tips(this, false, '导出失败：' + (error.message || '未知错误'));
        }
      }
    },

    // Excel导入
    async handleImportExcel(file) {
      // 验证文件类型
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                      file.type === 'application/vnd.ms-excel' ||
                      file.name.endsWith('.xlsx') || 
                      file.name.endsWith('.xls');
      
      if (!isExcel) {
        tips(this, false, '只能上传 Excel 文件（.xlsx 或 .xls）！');
        return false;
      }

      // 验证文件大小（限制为 10MB）
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        tips(this, false, '文件大小不能超过 10MB！');
        return false;
      }

      try {
        console.log('开始导入 Excel 文件:', file.name);

        // 创建 FormData 对象
        const formData = new FormData();
        formData.append('file', file);

        // 调用后端导入接口
        const result = await axios.post(
          '/bluetoothlight/web/router/multipart/neewerhome/manage/device/diySceneEffect/importExcel',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'accessToken': sessionStorage.getItem('accessToken')
            },
            withCredentials: true,
            timeout: 60000 // 导入可能需要更长时间，设置 60 秒超时
          }
        );

        console.log('导入响应:', result);

        if (result?.data?.resultStatus) {
          // 导入成功
          const successCount = result.data.resultData || 0;
          tips(this, true, `导入成功，共导入 ${successCount} 条数据`);
          
          // 刷新表格数据
          this.refreshData();
        } else {
          // 导入失败，显示错误信息
          tips(this, false, result?.data?.errorMessage || '导入失败');
        }
      } catch (error) {
        console.error('导入失败:', error);
        
        // 提供更明确的错误提示
        if (error.code === 'ECONNABORTED') {
          tips(this, false, '导入超时，请检查网络连接或文件大小');
        } else if (error.response && error.response.data) {
          // 处理后端返回的错误响应
          const responseData = error.response.data;
          tips(this, false, responseData.errorMessage || responseData.message || '导入失败');
        } else {
          tips(this, false, '导入失败：' + (error.message || '未知错误'));
        }
      }

      // 阻止默认上传行为
      return false;
    },

    // 通用复制方法（支持单行和多行）
    copyData(records) {
      // 如果传入的是单个对象，转换为数组
      const recordsArray = Array.isArray(records) ? records : [records];
      
      if (recordsArray.length === 0) {
        tips(this, false, "没有可复制的数据");
        return;
      }

      // 存储待复制的记录
      this.copyRecords = recordsArray;
      
      // 如果是单行复制，使用当前记录的版本作为默认值
      if (recordsArray.length === 1) {
        this.copySceneVersion = recordsArray[0].sceneVersion || "";
        this.copyEffectVersion = recordsArray[0].effectVersion || "";
      } else {
        // 批量复制时清空版本输入
        this.copySceneVersion = "";
        this.copyEffectVersion = "";
      }
      
      // 打开复制弹窗
      this.copyModalVisible = true;
    },
    
    // 一键复制（批量复制）
    handleBatchCopy() {
      if (this.selectedRows.length === 0) {
        tips(this, false, "请先选择要复制的数据");
        return;
      }
      this.copyData(this.selectedRows);
    },

    // 单行复制
    batchCopy(record) {
      this.copyData(record);
    },

    // 提交复制
    async handleCopySubmit() {
      // 验证场景版本格式（x.y）
      const sceneVersionPattern = /^\d+\.\d+$/;
      if (!this.copySceneVersion || !sceneVersionPattern.test(this.copySceneVersion)) {
        tips(this, false, "请输入正确的场景版本格式（x.y）");
        return;
      }

      // 验证光效应用版本格式（x.y）
      const effectVersionPattern = /^\d+\.\d+$/;
      if (!this.copyEffectVersion || !effectVersionPattern.test(this.copyEffectVersion)) {
        tips(this, false, "请输入正确的光效应用版本格式（x.y）");
        return;
      }

      this.copyFormLoading = true;

      try {
        // 辅助函数：确保字段是对象/数组，如果是字符串则解析
        const parseField = (field) => {
          if (typeof field === 'string') {
            try {
              return JSON.parse(field);
            } catch (e) {
              console.warn("字段解析失败:", e);
              return field;
            }
          }
          return field;
        };

        // 构造需要复制的数据数组
        const copyDataList = this.copyRecords.map(record => ({
          serialNumber: record.serialNumber,
          sortNumber: record.sortNumber,
          deviceType: record.deviceType,
          deviceModel: record.deviceModel,
          modelName: record.modelName,
          effectType: record.effectType,
          effectName: record.effectName,
          effectOrder: record.effectOrder,
          sceneVersion: this.copySceneVersion,
          effectVersion: this.copyEffectVersion,
          icon: record.icon,
          selectedIcon: record.selectedIcon,
          // 关键修复：确保 effect 和 effectControl 是真正的数组对象，而不是字符串
          effect: parseField(record.effect),
          effectControl: parseField(record.effectControl)
        }));

        // 构造请求数据
        const requestData = {
          dtoList: copyDataList
        };

        console.log("复制数据:", requestData);

        // 调用批量复制接口
        const result = await this.$post(
          "bluetoothlight/web/router/neewerhome/manage/device/diySceneEffect/batchCopy",
          requestData
        );

        if (result?.resultStatus) {
          const count = this.copyRecords.length;
          tips(this, true, count > 1 ? `成功复制 ${count} 条数据` : "复制成功");
          
          // 关闭弹窗
          this.copyModalVisible = false;
          this.copyFormLoading = false;
          
          // 如果是批量操作，清空选中状态
          if (this.copyRecords.length > 1) {
            this.selectedRowKeys = [];
            this.selectedRows = [];
          }
          
          // 清空复制相关数据
          this.copyRecords = [];
          this.copySceneVersion = "";
          this.copyEffectVersion = "";
          
          // 刷新表格数据
          this.refreshData();
        } else {
          tips(this, false, result?.message || "复制失败");
          this.copyFormLoading = false;
        }
      } catch (error) {
        console.error("复制失败:", error);
        tips(this, false, "复制失败");
        this.copyFormLoading = false;
      }
    },

    // 取消复制
    handleCopyCancel() {
      this.copyModalVisible = false;
      this.copyFormLoading = false;
      this.copyRecords = [];
      this.copySceneVersion = "";
      this.copyEffectVersion = "";
    },

    // 刷新列表（不改变查询条件）
    handleRefreshList() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.refreshData();
    },

    // 刷新
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    }
  }
};
</script>


<style lang="less" scoped>
.user_list_page {
  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
  
  // 拖拽句柄样式
  .drag-handle {
    cursor: move;
    color: #999;
    font-size: 16px;
    
    &:hover {
      color: #1890ff;
    }
  }
}
</style>
